import { memo } from "react";
import type { BatchJobPanelProps } from "../../batch_job_kind_contract";
import { AdmissionRecheckPanelBody } from "./AdmissionRecheckPanelBody";
import { useAdmissionRecheckPanel } from "./useAdmissionRecheckPanel";

/** Results panel for an admission_recheck batch job. */
export const AdmissionRecheckPanel = memo(function AdmissionRecheckPanel({
  job,
}: BatchJobPanelProps) {
  const panel = useAdmissionRecheckPanel(job);
  return <AdmissionRecheckPanelBody panel={panel} />;
});
